module.exports = __webpack_public_path__ + "media/audio27.342f7df4.mp3";